import { Injectable, Injector, forwardRef, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { LocalStorageService, SessionStorageService } from 'ngx-webstorage';
import { CookieService } from 'ngx-cookie-service';
import { AuthServerProvider } from '../auth/auth-jwt.service';
import { CoreConfigService } from '../config/core-config.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    private localStorage: LocalStorageService;
    private sessionStorage: SessionStorageService;
    private cookieService: CookieService;
    private configService: CoreConfigService;
    private authService: AuthServerProvider;

    constructor(@Inject(forwardRef(()=>Injector)) private injector:Injector) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if(this.localStorage==null) this.localStorage = this.injector.get(LocalStorageService);
        if(this.sessionStorage==null) this.sessionStorage = this.injector.get(SessionStorageService);
        if(this.cookieService==null) this.cookieService = this.injector.get(CookieService);
        if(this.authService==null) this.authService = this.injector.get(AuthServerProvider);
        if(this.configService==null) this.configService = this.injector.get(CoreConfigService);

        const token = this.authService.getToken();
        if (!!token && req.url.indexOf('oauth/token') === -1) {
            if ((!req.headers.get('NoAuthorization'))
                && this.configService.requestAuthMode!='COOKIE' 
                && (!this.cookieService.get("access_token"))) {
                const authReq = req.clone({ headers: req.headers.set('Authorization', 'Bearer ' + token) });
                return next.handle(authReq);
            }
        }
        return next.handle(req);
    }
}
